import * as React from "react";

function SvgRoktIcon(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 289.3 81"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <path d="M43.1,26c0-6.8-3.4-10.3-11.4-10.3H21.4v20.7h10.3C39.8,36.4,43.1,33,43.1,26z M65.6,26.2c0,8.3-4.2,14.1-12,18.5l17.2,34.4H46.8L33,50.6H21.4v28.5H0V1.5h35.1C56.1,1.5,65.6,11.6,65.6,26.2z M225.2,1.6l-8.4,16.4h27.4v61.2h21.6V18.1h23.6V1.6H225.2z" />
      <path
        fill="#420828"
        d="M206.4,1.6h11.7l-46.2,37.8V26.2L206.4,1.6L206.4,1.6z"
      />
      <path
        fill="#7D1345"
        d="M206.2,1.6h12.3l-17.8,34.7l-19.4,8.8C181.3,45.1,206.2,1.6,206.2,1.6z"
      />
      <path
        fill="#B51E6D"
        d="M181.2,45.1l19.4-8.8l21.2,42.8h-24.2L181.2,45.1L181.2,45.1z"
      />
      <path d="M172.3,1.6h-21.5v77.6h21.5V1.6z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M107.7,0c-11.1,0-20,3.6-26.7,10.9s-10.1,17-10.1,29.5v0.2c0,12.5,3.4,22.4,10.1,29.6C87.7,77.4,96.6,81,107.7,81s20-3.6,26.6-10.8c6.7-7.2,10.1-17.1,10.1-29.6v-0.2c0-12.5-3.4-22.3-10.1-29.5C127.7,3.7,118.7,0,107.7,0z M107.5,15.8c-4.5,0-8.2,2.3-10.9,6.8c-2.7,4.5-4.1,10.6-4.1,18.4v0.1c0,7.8,1.4,14,4.1,18.5c2.7,4.5,6.4,6.7,10.9,6.7c4.5,0,8.2-2.2,10.9-6.7c2.7-4.5,4.1-10.7,4.1-18.5V41c0-7.8-1.4-13.9-4.1-18.4S112.1,15.8,107.5,15.8L107.5,15.8z"
      />
    </svg>
  );
}

export default React.forwardRef(SvgRoktIcon);
